import {
  get,
  post,
  del,
  put
} from '@/util/request'

//新增
export const InsertUserGroup = (data) => {
  return post('/api/app/userGroup', data);
}
//修改
export const UpdateUserGroup = (data) => {
  return put('/api/app/userGroup', data);
}
//分页
export const GetUserGroupInfo = (data) => {
  return post('/api/app/userGroup/list', data);
}
export const DeleteUserGroup = (data) => {
  return del(`/api/app/userGroup/${data.userId}`);
}